import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@ncoder/ui';
import { QualityMetric } from '../../atoms/training/QualityMetric';

interface QualityAnalysisProps {
  overallQuality: number;
  totalRecords: number;
}

export const QualityAnalysis: React.FC<QualityAnalysisProps> = ({
  overallQuality,
  totalRecords,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Data Quality Analysis</CardTitle>
        <CardDescription>Review and improve your training data quality</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <QualityMetric 
            value={`${overallQuality}%`} 
            label="Overall Quality" 
            color="green" 
          />
          <QualityMetric 
            value={totalRecords.toLocaleString()} 
            label="Total Records" 
            color="blue" 
          />
        </div>
      </CardContent>
    </Card>
  );
};
